import { render } from "./InstitutionInfo.vue?vue&type=template&id=f1c59596&lang=pug"
import script from "./InstitutionInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionInfo.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__